import styled from 'styled-components';
import { colors, layout, responsiveBreakPoints } from '@styles/DesignVariables';
const { maxTablet } = responsiveBreakPoints;

interface HeaderProps {
	$backgroundColor?: string;
}

export const HeaderStyled = styled.header<HeaderProps>`
	background: ${(props: HeaderProps) => props.$backgroundColor || colors.whiteBackground};
	height: ${layout.headerHeight};
	border-bottom: 1px solid ${colors.borderColor};
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	img {
		max-width: 194px;
		@media screen and (${maxTablet}) {
			max-width: 136px;
		}
	}
	@media screen and (${maxTablet}) {
		height: auto;
	}
`;
